module.exports = __webpack_public_path__ + "6db167abf383aa0d13c322f09ecfcb75.MP3";